export default "__VITE_ASSET__CpT_WSR9__"